import moment from 'mj-moment'
import { isHoliday, isWeekendDay } from '@/utils/date'

const conditionDates = searchParams => {
  if (!searchParams) return []

  if (searchParams.params['start_or_end_at_gte']) return [searchParams.params['start_or_end_at_gte']]
  if (searchParams.params['start_at_gte']) return [searchParams.params['start_at_gte']]
  if (searchParams.params['start_dates[]'] && typeof searchParams.params['start_dates[]'] === 'string') return [searchParams.params['start_dates[]']]
  return searchParams.params['start_dates[]'] || []
}
const isValidDate = searchParams => {
  const searchConditionDates = conditionDates(searchParams)
  if (searchConditionDates.length === 0) return true

  return searchConditionDates.some(date => {
    const startDate = moment(date)
    return isWeekendDay(startDate) || isHoliday(startDate)
  })
}

const isLoggedIn = () => {
  // TODO: need to implement login validation logic
  // https://github.com/linkbal/mj-issues/issues/119
  return false
}

export const showSimilarGroupEvent = searchParams => {
  return isValidDate(searchParams) && isLoggedIn()
}
